import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

import LatestNews from "../../Shared/LatestNews";
import { GeneralBox } from "../../Shared/GeneralBox";
import { GeneralPlatform } from "../../Shared/Generalplatform";

import Testimonials from "./Testimonials"
import CallToAction from "./CallToAction"


// Import images
import AitoolsLogo from '../../Assets/Images/AiToolsLogo.png';
import MarketplaceLogo from '../../Assets/Images/MarketplaceLogo.svg';
import MarketinggeniusLogo from '../../Assets/Images/MarketingGeniusLogo.png';

import YoutubeLogo from '../../Assets/Images/Youtube_logo.png';
import GoogleLogo from '../../Assets/Images/Google_logo.png';
import FacebookLogo from '../../Assets/Images/Facebook_logo.png';
import ShopifyLogo from '../../Assets/Images/Shopify_logo.png';
import WordpressLogo from '../../Assets/Images/Wordpress_logo.png';
import MoreLogo from '../../Assets/Images/More_logo.png';

import ParticlesBG from "../../Shared/ParticlesBG";
import Search from "../../Shared/Search";


export default function Homepage() {

  // State for the search input
  const [searchTerm, setSearchTerm] = useState("");
  
  // State for blog posts
  const [blogPosts, setBlogPosts] = useState([]);
  const [blogLoading, setBlogLoading] = useState(true);

  // Fetch blog posts on component mount
  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/blog/posts?limit=3`);
        const data = await response.json();
        if (data.success && data.posts) {
          // Transform blog posts to match expected format
          const transformedPosts = data.posts.map(post => ({
            id: post.id,
            slug: post.slug,
            title: post.title,
            content: post.excerpt || post.content,
            image: post.featured_image || '/img/blog-placeholder1.jpg',
            tags: post.tags || [],
            author: post.author,
            date: {
              day: new Date(post.published_at).getDate().toString().padStart(2, '0'),
              month: new Date(post.published_at).toLocaleString('en-US', { month: 'long' })
            }
          }));
          setBlogPosts(transformedPosts);
        }
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      } finally {
        setBlogLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  // Function to handle search input changes
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Function to handle the search action when the user submits the form
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    console.log("Search term submitted: ", searchTerm);
    // Implement your search logic here
  };

  return (
    <div id="homepage">
      <section className="homepage">
        <div className="particles circle-bg ">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">Marketing</span> is where
                science meets <span className="color-font">creativity</span>
              </h1>
              <Search />
            </div>
          </div>

          <ParticlesBG />

          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      <section className="services">
        <div className="container">
          <h2><span className="color-font">Key Platform Component</span></h2>
          <div className="box-column-container">
            <div className="box-column">
              <GeneralBox
                title="Marketing Tools"
                link="/ai-marketing-tools"
                imageSrc={AitoolsLogo}
                description="Need help to take your marketing to the next level? Use our AI Marketing tools."
                className="homepage-box"
              />
            </div>
            <div className="box-column">
              <GeneralBox
                title="Marketplace"
                link="/marketing-services"
                imageSrc={MarketplaceLogo}
                description="Start growing your brand now. Build your marketing campaign with a modern experience."
                className="homepage-box"
              />
            </div>
            <div className="box-column">
              <GeneralBox
                title="Marketing Genius"
                link="/marketing-genius"
                imageSrc={MarketinggeniusLogo}
                description="Ask our Marketing Genius about your Marketing needs."
                className="homepage-box"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="shop-by-platform">
        <div className="container">
          <h2><span className="color-font">Shop by Platform</span></h2>

          <div>
            <GeneralPlatform 
              name="Youtube"
              link="/platforms/youtube"
              imageSrc={YoutubeLogo}
            />
          </div>
          <div>
            <GeneralPlatform 
              name="Google"
              link="/platforms/google"
              imageSrc={GoogleLogo}
            />
          </div>
          <div>
            <GeneralPlatform 
              name="Facebook"
              link="/platforms/facebook"
              imageSrc={FacebookLogo}
            />
          </div>
          <div>
            <GeneralPlatform 
              name="Shopify"
              link="/platforms/shopify_p"
              imageSrc={ShopifyLogo}
            />
          </div>
          <div>
            <GeneralPlatform 
              name="Wordpress"
              link="/platforms/wordpress"
              imageSrc={WordpressLogo}
            />
          </div>
          <div>
            <GeneralPlatform 
              name="More Platforms"
              link="/platforms/more"
              imageSrc={MoreLogo}
            />
          </div>
        </div>
      </section>
      <Testimonials/>
      {!blogLoading && blogPosts.length > 0 && <LatestNews data={blogPosts}/>}
    </div>
  )
}
